export function scrollToTop(smooth = true, delay = 0) {
    const performScroll = () => {
        const behavior = smooth ? 'smooth' : 'auto';

        window.scrollTo({ top: 0, behavior });

        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;

        const scrollContainer =
            document.querySelector('[data-scroll-container]') ||
            document.querySelector('.scroll-container') ||
            document.querySelector('main');
        if (scrollContainer) {
            if (smooth) {
                scrollContainer.scrollTo({ top: 0, behavior: 'smooth' });
            } else {
                scrollContainer.scrollTop = 0;
            }
        }
    };

    if (delay > 0) {
        setTimeout(performScroll, delay);
    } else {
        performScroll();
    }
}
